<template>
  <div>
    <van-swipe class="my-swipe" indicator-color="white" :loop="false">
      <van-swipe-item v-for="(item, i) of list" :key="i">
        <div class="shop">
          <ul>
            <li v-for="cItem of item" :key="cItem.goods_sn" @click="product(cItem.goods_sn)">
              <img :src="cItem.pic" loading="lazy" />
              <p>{{ cItem.goods_name }}</p>
            </li>
          </ul>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
import { Swipe, SwipeItem } from 'vant'

export default {
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  props: {
    cateList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data () {
    return {
      showCount: 10,
      list: [],
    }
  },
  methods: {
    product (id) {
      // this.$router.push({
      //   path: '/product',
      //   query: {
      //     cate_type: 1,
      //     type: 'cate',
      //     cat_id: id,
      //   },
      // })

      this.$router.push({
        path: '/prodetail?pid=159071',
        query: {
          pid: id
        },
      })
    },
  },
  watch: {
    cateList (value) {
      const { showCount } = this
      const list = []
      for (let i = 0; i < Math.ceil(value.length / showCount); i++) {
        this.list.push(value.slice(i * showCount, (i + 1) * showCount))
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.shop {
  font-size: 0.21rem;
  clear: both;
  background: #fff;
  min-height: 3.4rem;
  padding: 0.1rem 0;
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      margin: 0.1rem 0.1rem;
      text-align: center;
      flex-basis: 1.3rem;
      cat_pic {
        width: 1.13rem;
      }
      p {
        margin: 0;
        color: #000000;
      }
      a {
        display: block;
      }
      img {
        width: 1.13rem;
        height: 1.13rem;
      }
    }
  }
}
</style>